import { useMutation, useQuery } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

import useApiHelper from "../hooks/useApiHelper";
import {
  IRecordStockSearch,
  IStockSearchResponse,
  IVehicleDemandResponse,
} from "../models/stockSearch/IStockSearch";

/**
 * Saved stock searches. `record` is fire-and-forget from the Stock page: a search must never fail or
 * slow down because the demand row could not be written, so there is no toast and the error only
 * goes to Sentry.
 */
export default function useStockSearch() {
  const { post } = useApiHelper();

  const record = useMutation(
    (request: IRecordStockSearch) => post<IRecordStockSearch, IStockSearchResponse>("/stocksearch", request),
    {
      onError: (error: unknown) => {
        Sentry.captureException(error);
      },
    }
  );

  return { record };
}

/** Searches and open part requests, within the retention window, that match this vehicle. */
export function useVehicleDemand(vehicleId: string | undefined, enabled = true) {
  const { get } = useApiHelper();

  const demand = useQuery({
    queryKey: ["vehicleDemand", vehicleId],
    queryFn: () => get<IVehicleDemandResponse>(`/stocksearch/vehicle/${vehicleId}`),
    enabled: !!vehicleId && enabled,
    staleTime: 1000 * 60 * 5,
  });

  return { demand };
}
